<template>
  <div class="contents contents--pt">
    <section class="Form _min-h">
      <div class="inner">
        <div class="Form--pt">
          <div class="Form__unsubscribe_top">
            <div class="Form__unsubscribe_tx_area">
              <p class="Form__unsubscribe_tx">
                退会してしまうと…
              </p>
              <div class="Form__label Form__label--pd_md Form__unsubscribe_top">
                <ul class="List">
                  <li v-if="isSpecial" class="List__dot">
                    これまでのマインドフルネスログのデータが消えてしまいます。<br>
                    また、通常料金は{{ Math.round(normalPrice / 1.1) }}円（税込{{ normalPrice }}円）となっておりますが、{{ userFullname }}様がご加入されているプランですと{{ Math.round(specialPrice / 1.1) }}円（税込{{ specialPrice }}円）でずっと受講することが可能です。<br>
                    一度ご退会されますと、このプランは無効となりますのでご注意ください。
                  </li>
                  <li v-else class="List__dot">
                    これまでのマインドフルネスログのデータが消えてしまいます。
                  </li>
                </ul>
              </div>
            </div>
            <img class="Form__unsubscribe_img" src="assets/img/unsubscribe.png" alt="退会してしまうと…">
          </div>
          <div class="Form__btn_area Form__unsubscribe_bottom">
            <router-link
              to="/change"
              class="Btn__blue Form__btn"
            >
              前のページに戻る
            </router-link>
            <router-link
              :to="{name: 'Enquete'}"
              class="Btn__blue Form__btn Form__btn--mg_ _back-cl04"
            >
              退会のお手続きに進む
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import authService from '@/services/authService'
export default {
  name: 'Unsubscribe',
  data() {
    return {
      userFullname: '',
      specialPrice: 0,
      normalPrice: 0,
      isSpecial: null
    }
  },
  created() {
    this.getPaymentInfo()
  },
  methods: {
    async getPaymentInfo() {
      this.$store.dispatch('loading/updateLoading', true)
      const response = await authService.getUserPaymentInfo()
      const masterProduct = response.master_product
      const normalProduct = response.normal_product
      this.userFullname = response.user_name
      this.isSpecial = masterProduct.special_cost
      if (this.isSpecial && normalProduct) {
        this.specialPrice = masterProduct.price
        this.normalPrice = normalProduct.price
      }
      this.$store.dispatch('loading/updateLoading', false)
    }
  }
}
</script>
